/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListMarketMakersOptions,
  ListMarketMakersStatus200,
  ListMarketMakersStatus400,
  ListMarketMakersStatus401,
  ListMarketMakersStatus403,
  ListMarketMakersStatus404,
  ListMarketMakersStatus409,
  ListMarketMakersStatus500,
} from '../types/ListMarketMakers'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listMarketMakers } from '../clients/listMarketMakers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listMarketMakersQueryKey = ({
  query,
}: Omit<ListMarketMakersOptions, 'headers'> = {}) =>
  [{ url: '/v1/market-makers' }, ...(query ? [query] : [])] as const

type ListMarketMakersQueryKey = ReturnType<typeof listMarketMakersQueryKey>

export function listMarketMakersQueryOptions(
  { query }: ListMarketMakersOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listMarketMakersQueryKey({ query })
  return queryOptions<
    ListMarketMakersStatus200,
    ResponseErrorConfig<
      | ListMarketMakersStatus400
      | ListMarketMakersStatus401
      | ListMarketMakersStatus403
      | ListMarketMakersStatus404
      | ListMarketMakersStatus409
      | ListMarketMakersStatus500
    >,
    ListMarketMakersStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listMarketMakers({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Admin only. All percentages are fractions in [0,1]. Ordered by created_at descending, then ID. An empty page returns [].
 * @summary List market makers
 * {@link /v1/market-makers}
 */
export function useListMarketMakers<
  TData = ListMarketMakersStatus200,
  TQueryData = ListMarketMakersStatus200,
  TQueryKey extends QueryKey = ListMarketMakersQueryKey,
>(
  {
    query,
  }: { query?: ListMarketMakersOptions['query'] | (() => ListMarketMakersOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListMarketMakersStatus200,
        ResponseErrorConfig<
          | ListMarketMakersStatus400
          | ListMarketMakersStatus401
          | ListMarketMakersStatus403
          | ListMarketMakersStatus404
          | ListMarketMakersStatus409
          | ListMarketMakersStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listMarketMakersQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listMarketMakersQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | ListMarketMakersStatus400
      | ListMarketMakersStatus401
      | ListMarketMakersStatus403
      | ListMarketMakersStatus404
      | ListMarketMakersStatus409
      | ListMarketMakersStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
